<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <h1>Bienvenue</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({})
};
</script>


<style>
</style>
